// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0b30294c","703":"a20f580a","787":"1cd31a9e"}[chunkId] + ".chunk.js";
};